module.exports = __webpack_public_path__ + "static/media/full-logo.bdda0f04.svg";